import { render, staticRenderFns } from "./RegionalProfile.vue?vue&type=template&id=541ee110"
import script from "./RegionalProfile.vue?vue&type=script&lang=js"
export * from "./RegionalProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports